import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import BooksService from './../../services/books.service';
import models_V2Service from './../../services/models_V2.service';
import ComponentTable from '../../components/ComponentTable';
import BackButton from '../../components/BalanceComponent/BackButton';

export default function TextbookAssignmentHistory() {
    const { t } = useTranslation();
    const { id, student_id } = useParams();

    return (
        <Fragment>
            <BackButton to={id ? `/groups/${id}` : `/students`} label={id ? t('sidebar.groups') : t('userBankSorobanPage.students')} />
            <h2 className="container-header">{t('books.assignmentHistory')}</h2>
            <ComponentTable
                source={{
                    getData: (page, size, sort, filter) =>
                        BooksService.getBookAssignmentHistory(false, {
                            userId: student_id,
                        }),
                    getModel: () => models_V2Service.GetBookAssignmentHistory(false),
                }}
                actions={[]}
                selectable={true}
                title={t('modals.list')}
                enableSettings
                toolbarvisible={true}
                typeTable="textbookAssignmentHistory"
            />
            </Fragment>
    );
}
